let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6WZ4F")).then(() => parcelRequire('dPZiA'));